import { FieldsTable } from './FieldsTable';

export default FieldsTable;
